// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/peso-equipaje-flights/list',
    name: 'peso-equipaje-flights-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/flights/PesoEquipaje.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_peso_equipaje_flights',
    },
  },
]

export default formTable
